import React from "react";
import { DialogContent, Grid, Link, List, ListItem, makeStyles, TextField, Typography } from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";

import classNames from "classnames";
import FacebookLogoDisabled from "../../resources/facebookIconDisabled.png";
import TwitterLogoDisabled from "../../resources/twitterLogoDisabled.png";

const useStyles = makeStyles(() => ({
    copyButton: {
        width: "100%",
        height: 51,
        backgroundColor: "#5bb2f6",
        marginBottom: 8,
        color: "#FFF",
        textAlign: "center",
        verticalAlign: "middle",
        "& span": {
            display: "inline-block",
            marginTop: 16,
        },
        cursor: "pointer",
    },
    urlInput: {
        maxHeight: 51,
        borderRadius: "0px",
        fontSize: "12px",
        [`& fieldset`]: {
            borderRadius: 0,
        },
    },
    listHorizontal: {
        display: "flex",
        flexDirection: "row",
        padding: 0,
    },
    listItem: {
        width: 70,
        "&:nth-of-type(2)": {
            width: 95,
        },
    },
    socialIcons: {
        width: 40,
        height: 40,
        marginTop: -5,
    },
    listItemSubContainer: {
        textAlign: "center",
    },
    disabledButton: {
        backgroundColor: "#a7a7a7",
    },
    disabledText: {
        color: "#a7a7a7",
        pointerEvents: "none",
        cursor: "default",
    },
    disabledAnchor: {
        pointerEvents: "none",
        cursor: "default",
        color: "#b4b4b4",
    },
}));

interface Props {
    url: string;
    handleCopy: () => void;
}

export function UnsharedContent(props:Props){
    const { url } = props;
    const classes = useStyles();

    return (
      <DialogContent>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Typography style={{ marginBottom: 8 }} className={classes.disabledText} variant="subtitle2" >
              Link for sharing
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              id="url"
              value={url}
              fullWidth
              InputProps={{
                readOnly: true,
                className: classNames(classes.urlInput, classes.disabledText),
                id: "urlInput",
                disabled: true,
              }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={3}>
            <div
              className={classNames(classes.copyButton, classes.disabledButton)}
              style={{ cursor: "default", pointerEvents: "none" }}
              onClick={props.handleCopy}
            >
              <span>COPY LINK</span>
            </div>
          </Grid>
        </Grid>
        <hr />
        <Typography style={{ marginBottom: 8, marginTop: 12 }} className={classes.disabledText} variant="subtitle2" >
          More sharing options
        </Typography>
        <div style={{ maxWidth: 300 }}>
          <List className={classes.listHorizontal}>
            <ListItem className={classes.listItem}>
              <div className={classes.listItemSubContainer}>
                <EmailIcon fontSize="large" style={{ color: "#b4b4b4" }} />
                <Link component="button" className={classes.disabledAnchor}>Email</Link>
              </div>
            </ListItem>
            <ListItem className={classes.listItem}>
              <div className={classes.listItemSubContainer}>
                <img alt="Facebook" className={classes.socialIcons} src={FacebookLogoDisabled}  />
                <Link component="button" className={classes.disabledAnchor}>Facebook</Link>
              </div>
            </ListItem>
            <ListItem className={classes.listItem}>
              <div className={classes.listItemSubContainer}>
                <img alt="Twitter" className={classes.socialIcons} src={TwitterLogoDisabled} />
                <Link component="button" className={classes.disabledAnchor}>Twitter</Link>
              </div>
            </ListItem>
          </List>
        </div>
      </DialogContent>
    );
}